import { dataAuditApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';
import { ProductInfoResponse } from 'src/types';

export const getProductInfo = (config: AxiosRequestConfig = {}) =>
  dataAuditApi.get<ProductInfoResponse>('/api/v1/productInfo', config);
